<template>
    <router-view></router-view>

    <el-backtop :bottom="100" :right="10">
        <img class="fixImg" src="@/assets/topRight.png" />
    </el-backtop>
</template>

<script>
export default {
  name: 'App',
  components: {

  },
  data(){
      return{

      }
  },
  mounted( ) {
       document.title = 'Your Overseas Life Assistant';
    //   document.title = "您的海外生活助手";
      if(location.href.indexOf("iframehome")==-1){
        // var script = document.createElement('script');
        // script.src = "https://code.jivosite.com/widget/UuurllI3Ip";
        // script.async = true; 
        // document.body.appendChild(script);
      }
  },
  methods:{

  }
}
</script>

<style>
  body{
      margin: 0;
      overflow-x: hidden;
      background-color: white;
  }

  .fixImg{
      width: 20px;
      height: 20px;
      margin: 12px;
  }

  @media (max-width: 768px) {
      .fixImg{
          width: 32px;
          height: 32px;
      }
  }
</style>
